// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles for eeyonetim.com */

body {
  margin: 0;
  padding: 0;
  font-family: 'Roboto', 'Segoe UI', 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #1976d2;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #1565c0;
}

/* Mobile optimizations */
@media (max-width: 600px) {
  .MuiContainer-root {
    padding-left: 12px;
    padding-right: 12px;
  }
}

/* Print styles */
@media print {
  body {
    background-color: #fff;
  }
  
  .no-print {
    display: none !important;
  }
}



`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,SAAS;EACT,UAAU;EACV,sDAAsD;EACtD,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Global Styles for eeyonetim.com */\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'Roboto', 'Segoe UI', 'Arial', sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n/* Scrollbar styling */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #1976d2;\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #1565c0;\r\n}\r\n\r\n/* Mobile optimizations */\r\n@media (max-width: 600px) {\r\n  .MuiContainer-root {\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n  }\r\n}\r\n\r\n/* Print styles */\r\n@media print {\r\n  body {\r\n    background-color: #fff;\r\n  }\r\n  \r\n  .no-print {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
